import styled from 'styled-components';
import InfoPath from '../../../../images/membership/info.svg';
import LockPath from '../../../../images/products/yellow-lock.svg';
import SuccessCheckIcon from '../../../../images/membership/success-check.svg';
import { FlexContainer } from './FlexContainer';
import { CustomLabel } from './CustomLabel';
import { theme } from '../theme';

interface IStyleProps {
  marginTop?: string;
  inActive?: boolean;
  height?: string;
  width?: string;
  heightWidth?: string;
  margin?: string;
  src?: string;
  bgColor?: string;
  bgSize?: string;
  borderRadius?: string;
  customHeight?: string;
}

const { text, border, common, boxShadow } = theme.palette;

export const InfoIcon = styled.span<IStyleProps>`
  vertical-align: sub;
  width: 18px;
  height: ${props => props.height || '18px'};
  margin-left: 10px;
  background: url(${InfoPath});
  display: inline-block;
  margin-top: ${props => props.marginTop || '0px'};
  background-repeat: no-repeat;
`;
export const LockIcon = styled.span<IStyleProps>`
  vertical-align: sub;
  width: 15px;
  height: 18px;
  margin-left: 10px;
  background: url(${props => props.src || LockPath});
  display: inline-block;
  margin-top: ${props => props.marginTop || '0px'};
  background-repeat: no-repeat;
  background-size: 13px;
`;
export const SuccessCheck = styled.span<IStyleProps>`
  vertical-align: sub;
  width: 20px;
  height: ${props => props.height || '16px'};
  margin-left: 10px;
  background: url(${props => props.src || SuccessCheckIcon});
  display: inline-block;
  margin-top: ${props => props.marginTop || '0px'};
  background-repeat: no-repeat;
  background-size: ${props => props.bgSize || '14px'};
`;
export const StyledTable = styled.div<IStyleProps>`
  .styled-table {
    border-radius: 10px;
    margin-top: ${props => props.marginTop || '20px'};
    background-color: #fff;
    width: auto;
    border-spacing: 0;
    border-collapse: separate;

    tr:last-child td:last-child {
      border-bottom-right-radius: 10px;
    }

    tr:last-child td:first-child {
      border-bottom-left-radius: 10px;
    }
    tr td:first-child {
      border-left: 2px solid #f5f5f5;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      max-width: 150px;
      width: 150px;
      min-width: 150px;
      text-align: left;
    }
    tr:first-child td {
      border-top: 2px solid #f5f5f5;

      &:last-child {
        border-top: none;
      }
    }

    th {
      padding: 15px 10px 10px;
      color: #777;
      font-size: 14px;
      font-weight: 600;
      background-color: #f5f5f5;
      border-bottom: 2px solid #fff;
      text-align: center;
      &:first-child {
        border-top-left-radius: 10px;
      }

      &:last-child {
        border-top-right-radius: 10px;
        background-color: #fff;
        padding-top: 15px;
      }
    }
    td {
      padding: 10px;
      margin-bottom: 2px;
      background-color: #f5f5f5;
      border-bottom: 2px solid #fff;
      text-align: center;
      max-width: 300px;
      &:first-child {
        color: #586db9;
        font-weight: 600;
      }
      &:last-child {
        width: 60px;
        max-width: 60px;
        min-width: 60px;
      }
      input {
        width: 120px;
        /* width: auto; */
        /* max-width: 200px; */
        border: 1px solid ${theme.palette.border.dark};
        border-radius: 4px;
        padding: 4px 12px;
      }
    }
    td:last-child,
    th:last-child {
      background-color: #fff;
      padding-top: 15px;
    }
    tr {
      margin-bottom: 2px;
    }
    .displayed-price {
      color: #aaa;
    }
  }

  .delete-row-btn {
    background: transparent;
    border: none;
    padding: 0px;
    > img {
      height: 17px;
      vertical-align: baseline;
    }
  }
  &.basic-table {
    width: 100%;
    table {
      margin-bottom: 0px;
    }
    th,
    td {
      color: #555;
      font-weight: 400;
    }
    td {
      border-bottom: none;
    }
  }
`;

export const StatusCircle = styled.div<IStyleProps>`
  height: ${props => props.heightWidth || '15px'};
  width: ${props => props.heightWidth || '15px'};
  border-radius: 50%;
  text-align: center;
  background-color: ${props => (props.inActive ? '#FF8080' : props.bgColor || '#ABD596')};
  margin: ${props => props.margin || '0px'};
`;
export const LoadingWrapper = styled.div<IStyleProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${props => (props.height ? `calc(100vh - ${props.height})` : props.customHeight || 'calc(100vh - 260px)')};
  width: 100%;
`;
export const CustomWidth = styled.div<IStyleProps>`
  width: ${props => props.width || '100%'};
`;
export const LeftBanner = styled.div<IStyleProps>`
  position: absolute;
  left: 0;
  top: 0;
  transform: translate(0px, 0px);
  border-radius: 8px 0px 0px 8px;
  width: 35px;
  height: 100%;
  background-color: ${props => props.bgColor || '#556bb8'};
  label {
    transform: translate(-50%, -50%) rotate(270deg);
    position: relative;
    top: 50%;
    left: 50%;
    color: #fff;
    text-transform: uppercase;
    font-size: 18px;
  }
  @media (min-width: 300px) and (max-width: 1200px) {
    transform: translate(0px, 0px);
    width: 100%;
    height: 35px;
    border-radius: 8px 8px 0px 0px;
    label {
      transform: translate(-50%, -50%) rotate(360deg);
      top: 50%;
      left: 50%;
    }
  }
`;
export const TopBanner = styled.div<IStyleProps>`
  width: calc(100% + 2px);
  position: absolute;
  left: 0;
  top: 0;
  transform: translate(-1px, -45px);
  border-radius: 15px 15px 0px 0px;
  /* width: 100%; */
  height: 45px;
  background-color: ${props => props.bgColor || '#556bb8'};
  border: 1px solid ${props => props.bgColor || '#556bb8'};
  label {
    transform: translate(-50%, -50%);
    position: relative;
    top: 50%;
    left: 50%;
    color: #fff;
    text-transform: uppercase;
    font-size: 18px;
  }
`;
export const NavHorizontalBar = styled.div<IStyleProps>`
  height: 15px;
  width: 70px;
  background-color: ${props => props.bgColor || '#dddddd'};
  border-radius: 25px;
  cursor: pointer;
`;
export const PriceDescriptionBlock = styled.div<IStyleProps>`
  display: flex;
  gap: 15px;
  width: 500px;
  background-color: #f8f8f8;
  border: 1px solid #ccc;
  padding: 25px 20px;
  border-radius: 10px;
  margin: 30px 0px;
  flex-direction: column;
  ${FlexContainer}.price-flex {
    > div {
      width: 66%;
    }
    > ${CustomLabel} {
      width: 33%;
    }
    .price-sub-flex > ${CustomLabel} {
      &:first-child {
        width: 40%;
      }

      &:last-child {
        font-weight: 400;
        width: 60%;
      }
    }
    ${CustomLabel} {
      font-size: 14px;
      font-weight: 600;
      display: inline-block;
      word-break: break-word;
    }
  }
`;
export const RecommendedFreeProduct = styled.div<IStyleProps>`
  display: flex;
  align-items: center;
  gap: 15px;
  width: 100%;
  img {
    height: 60px;
    width: 50px;
    object-fit: contain;
  }
  label {
    text-align: left !important;
    font-size: 14px !important;
  }
`;

export const OverlayDropdownMenu = styled.div<IStyleProps>`
  position: relative;
  .dropdown-menu {
    /* max-height: 300px; */
    min-height: 150px;
    height: auto;
    max-height: 250px;
    min-width: 200px;
    width: auto;
    max-width: 500px;
    display: block;
    position: absolute;
    overflow-y: visible;
    /* overflow-y: auto; // Creating issue for tooltip */
    left: 50%;
    top: 0;
    transform: translate(-50%, 30px);
    border: 1px solid #556bb8;
    background-color: #fff;
    img {
      height: 20px;
      width: 20px;
      margin-right: 15px;
      margin-bottom: 5px;
    }
    a {
      padding-bottom: 0px;
      &:active {
        background-color: transparent;
        color: #212529;
      }
      &:focus {
        outline: none;
      }
    }

    &::before {
      position: absolute;
      top: 0px;
      left: 59%;
      border-right: 10px solid transparent;
      border-bottom: 10px solid #556bb8;
      border-left: 10px solid transparent;
      content: '';
      transform: translate(-50%, -10px);
    }
    &::after {
      position: absolute;
      top: 0px;
      left: 59%;
      border-right: 10px solid transparent;
      border-bottom: 10px solid #fff;
      border-left: 10px solid transparent;
      content: '';
      transform: translate(-50%, -9px);
    }
    > div {
      overflow-y: auto;
      /* height: 280px; */
      max-height: calc(100vh - 250px);
      height: 100%;

      &::-webkit-scrollbar {
        width: 0.3em;
        height: 0.4em;
        background-color: #15283717;
        border-radius: 10px;
      }
      &::-webkit-scrollbar-thumb {
        outline: 1px solid rgba(21, 40, 55, 0.3);
        background-color: rgba(21, 40, 55, 0.3);
        border-radius: 10px;
      }
    }
  }
  &.activity-graph-dpdn {
    display: flex;
    gap: 8px;
    align-items: center;
    .dropdown-menu {
      min-width: 330px;
      min-height: 30px;
      height: auto;
      max-height: 150px;
      padding: 15px 0px;
      /* overflow-y: auto; */
      /* background-color: #f7f8fb;
            border: none;
            &::before {
                border-bottom: 10px solid #f7f8fb;
            }
            &::after {
                border-bottom: 10px solid #f7f8fb;
            } */
    }
    .dropdown-item-wrapper {
      overflow-y: auto;
      min-height: 30px;
      height: auto;
      max-height: 150px;
    }
    ${CustomLabel} {
      font-size: 14px;
      line-height: 18px;
      font-weight: 400;
      color: #000;
    }
    .activity-graph-img {
      overflow-y: hidden;
      /* height: 12px; */
      width: 30px;
      img {
        height: 12px;
        width: 15px;
        margin-bottom: 10px;
      }
    }
    .dropdown-item {
      display: flex;
      width: 100%;
      ${FlexContainer} {
        /* gap: 10px; */
        width: 100%;
        align-items: flex-start;
        flex: 1;
      }
      &.active {
        background-color: transparent;
        label:first-child {
          color: #556bb8;
        }
      }
      .dpdn-overlay {
        &:first-child {
          width: 90px;
          font-weight: 600;
        }
      }
    }
    .activity-options-wrapper {
      background: #fff;
      &:hover {
        background: #fff;
      }
      .prior-outer-wrapper {
        gap: 70px;
      }
    }
    a {
      padding-bottom: 0px;
      &:hover,
      &:active,
      &:focus {
        background-color: #fff;
      }
    }
  }
`;
export const StatusDropdownWrapper = styled.div<IStyleProps>`
  .status-dropdown {
    min-width: 110px;
    width: auto;
    max-width: 250px;
    .header {
      min-width: 110px;
      width: auto;
      max-width: 250px;
      border: none;
      padding: 0px 32px 0px 0px;
    }
    .select-header-span {
      background: ${props => props.bgColor || '#FFE5E5'};
      color: ${props => props.color || '#FF0000'};
      display: inline-block;
      text-align: center;
      padding: 0px 15px;
      line-height: 30px;
      border-radius: 4px;
      height: 30px;
      font-size: 16px;
      font-weight: 600;
      min-width: 100px;
      max-width: 150px;
      width: auto;
    }
    .select-header-icon {
      border-left: none;
      height: 25px;
      width: 30px;
    }
    .options-menu {
      transform: translate(0px, 35px);
    }
  }
`;

export const InputColorBlock = styled.div<IStyleProps>`
  height: 40px;
  width: 40px;
  background-color: ${props => props.bgColor || 'transparent'};
  border-radius: ${props => props.borderRadius || ' 0px 4px 4px 0px'};
  /* border: 1px solid #aaa; */
  border-left: 1px solid #aaa;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  .colorBlock-trash-icon {
    height: 20px;
    width: 20px;
    display: none;
    cursor: pointer;
  }
  &:hover {
    .colorBlock-trash-icon {
      display: block;
    }
  }
`;

export const DropdownOverlay = styled.div`
  position: absolute;
  top: 0px;
  left: 0px;
  max-height: 200px;
  background: ${common.white};
  width: 100%;
  transform: translate(0px, 50px);
  box-shadow: ${boxShadow.main} 0px 4px 4px;
  border: 1px solid ${boxShadow.main};
  padding: 10px;
  z-index: 1000;
  .searchable-dropdown-input {
    width: 100%;
    height: 35px;
    border: none;
    border-bottom: 1px solid ${border.darker};
    padding: 8px 7px;
    border-radius: 0px;
    font-size: 16px;
    line-height: 19px;
    margin-bottom: 10px;
    color: ${text.main};
    &:focus {
      outline: none;
    }
  }
`;
export const FooterOption = styled.div`
  padding: 10px;
  border-top: 1px solid #e0e0e0;
  background-color: #f8f8f8;
  color: #556bb8;
  display: flex;
  align-items: center;
  cursor: pointer;
  img {
    width: 16px;
    height: 16px;
    margin-right: 8px;
  }
`;
